import { getMockPassportAccount } from '@src/services/mock-passport-account';

/**
 * Mocks the frontend login identity on non-master URLs carrying `?_mock_passport_account=<full-account>`.
 *
 * The XPASS SDK loads synchronously from the static HTML template (CommonLogin partial), so `window.XPASS`
 * already exists when this startup task runs — before renderApp and before any page data flow reads
 * `u_account` (account-info isLogin/username, the shared activity-session owner). Writing the URL account
 * here keeps both frontend state and request identity (service-layer injection) sourced from the same
 * parameter, so the whole page runs under one simulated account without a real login.
 *
 * Boundaries: an explicit XPASS signin/exit still overwrites `u_account` afterwards (user action wins);
 * when the XPASS SDK itself is absent this task skips instead of creating a login-only shell object,
 * because XPASS also owns signin/exit behavior an empty stub cannot provide.
 */
export default function initMockPassportAccount() {
  const mockPassportAccount = getMockPassportAccount();
  if (!mockPassportAccount || typeof window === 'undefined' || !window.XPASS) {
    return;
  }

  window.XPASS.u_account = mockPassportAccount;
}
